import apiClient from './client';

export const creatorsAPI = {
  // 30s override of the shared 10s timeout: the list is fast now (indexed grouped
  // count) but a cold cache / DB-load spike can push the first call a few seconds.
  getAll: (params) => apiClient.get('/creators', { params, timeout: 30000 }),
  getOne: (id) => apiClient.get(`/creators/${id}`),
  // Lightweight live check for polling — same liveStatus shape as getOne
  // without the creator's whole content history attached.
  getLiveStatus: (id) => apiClient.get(`/creators/${id}/live-status`),
  create: (data) => apiClient.post('/creators', data),
  // Bulk create needs longer timeout as it fetches data from external APIs for each creator
  bulkCreate: (creators) => apiClient.post('/creators/bulk', { creators }, { timeout: 120000 }),
  update: (id, data) => apiClient.put(`/creators/${id}`, data),
  // Archive (soft delete) - keeps data but hides creator and stops scraping
  delete: (id) => apiClient.delete(`/creators/${id}`),
  archive: (id) => apiClient.delete(`/creators/${id}`),
  // Restore archived creator
  restore: (id) => apiClient.post(`/creators/${id}/restore`),
  // Get archived creators list
  getArchived: () => apiClient.get('/creators/archived/list'),
  getGenres: () => apiClient.get('/creators/genres/list'),
  getCountries: () => apiClient.get('/creators/countries/list'),
  searchByGenre: (genre) => apiClient.get(`/creators/search/by-genre?genre=${genre}`),
  // Fetch period stats (avg CCV, peak CCV, watch hours) for 3, 7, 30, 60, 90 days,
  // computed from our own monitored Twitch streams. Longer timeout (120s) as a buffer.
  getPeriodStats: (id) => apiClient.get(`/creators/${id}/period-stats`, { timeout: 120000 }),
  // Pre-computed channel-wide rollup from CreatorRollup table (refreshed nightly).
  // Returns avg/peak CCV, watch hours, streamtime, and games played for the window.
  // Currently only periodDays=30 is populated.
  getRollup: (id, days = 30) => apiClient.get(`/creators/${id}/rollup`, { params: { days } }),
  // Daily follower/subscriber growth snapshots (collected nightly; history
  // starts 2026-06-10). Returns { days, platforms: { youtube: [...], twitch: [...] } }
  getGrowth: (id, days = 90) => apiClient.get(`/creators/${id}/growth`, { params: { days } }),
  // Force refresh platform IDs from URLs
  refreshPlatformIds: (id) => apiClient.post(`/creators/${id}/refresh-platform-ids`),
  // Scan bios across all linked platforms + aggregator pages (Linktree/carrd)
  // to find a public contact email. Pass force=true to overwrite an existing one.
  // Can take 60+ seconds because it may spin up headless browsers for IG/TikTok/Twitter.
  refreshEmail: (id, force = false) =>
    apiClient.post(`/creators/${id}/refresh-email${force ? '?force=1' : ''}`, null, { timeout: 180000 }),

  // CSV export — receives the current filters and returns a downloadable CSV.
  // Returns a Blob so the caller can kick off a download.
  exportCsv: (params) =>
    apiClient.get('/creators/export.csv', { params, responseType: 'blob' }),
};
